module.exports = __webpack_public_path__ + "zilky-v-obliceji_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/zilky-v-obliceji_2_after.jpg
// module id = 995
// module chunks = 0